module.exports = __webpack_public_path__ + "img/blog-one.bb92514c.svg";